import style from "../style.module.sass"
import { useStores } from "../../../../../hooks";
import { observer } from "mobx-react";
import { Trans, useTranslation } from "react-i18next";
import locationIcon from "../assets/location.svg";
import phoneIcon from "../assets/phone.svg";
import instagramIcon from "../assets/instagram.svg";
import websiteIcon from "../assets/website.svg";
import whatsappIcon from "../assets/whatsapp.svg";
import telegramIcon from "../assets/telegram.png";
import WorkingSchedule from "./WorkingSchedule";
import CloseButton from "../../../../../components/buttons/closeButton";
import useSwipeToDismiss from "../../../../../hooks/useSwipeToDismiss";

const InfoDetails = () => {
    const { menuStore, generalMenuStore, generalStore } = useStores();
    const { i18n, t } = useTranslation(['general']);
    const openDetailes = generalMenuStore.isDetailsModalVisible;

    const { sheetRef, scrollRef, offset, opacity, horizontalOffset, isDragging } = useSwipeToDismiss({
        isOpen: openDetailes,
        onDismiss: () => {
            generalMenuStore.onOverlayClick && generalMenuStore.onOverlayClick();
        }
    });

    const classes = [style.infoDetailesSection];
    if (openDetailes) {
        classes.push(style.open)
    }
    if(!openDetailes){
        return null;
    }

    const closeInfoDetails = () => {
        generalMenuStore.isDetailsModalVisible = false;
        generalMenuStore.isOverlayOpen = false;
        generalMenuStore.onOverlayClick = undefined;
        document.body.style.overflow = 'auto';
    };

    const legalInfo = generalStore.extractLegalInfo();

    return (
        <>
            <div className={classes.join(" ")}
                 ref={sheetRef}
                 style={{
                     top: 20,
                     transform: `translateY(${offset}px)`,
                     opacity,
                     left: horizontalOffset,
                     right: horizontalOffset,
                     transition: isDragging ? 'none' : undefined,
                 }}
            >
                <div className={style.infoDetailsSectionContainer} ref={scrollRef}>

                    <div className={style.shadowContainer}>
                        <p className={style.sectionTitle}>О ресторане</p>
                        {menuStore.menu.organizationBranchId != 686 && <WorkingSchedule/>}
                        {menuStore.menu.data.addressDetails.title !== null && menuStore.menu.data.addressDetails.title[i18n.language] &&
						<div className={style.address}>
							<div className={style.detailsIcon}>
								<img src={locationIcon} alt=""/>
							</div>
							<a >
								<p>{menuStore.menu.data.addressDetails.title[i18n.language]}</p>
							</a>

						</div>
                    }
                        {menuStore.menu.data.contactDetails.phoneNumber !== null &&
							<div className={style.phoneNumber}>
								<div className={style.detailsIcon}>
									<img src={phoneIcon} alt=""/>
								</div>
								<a href={'tel:' + menuStore.menu.data.contactDetails.phoneNumber}>
									<p>{menuStore.menu.data.contactDetails.phoneNumber}</p>
								</a>
							</div>
                        }
                        {menuStore.menu.data.contactDetails.instagram !== null &&
							<div className={style.instagram} style={{ marginTop: '20px' }}>
								<div className={style.detailsIcon}>
									<img src={instagramIcon} alt=""/>
								</div>
								<a href={'https://www.instagram.com/' + menuStore.menu.data.contactDetails.instagram}>
									<p>@{menuStore.menu.data.contactDetails.instagram}</p>
								</a>
							</div>
                        }
                        {menuStore.menu.data.contactDetails.websiteUrl !== null &&
							<div className={style.websiteIcon}>
								<div className={style.detailsIcon}>
									<img src={websiteIcon} alt=""/>
								</div>
								<a href={'https://' + menuStore.menu.data.contactDetails.websiteUrl}>
									<p>{menuStore.menu.data.contactDetails.websiteUrl}</p>
								</a>
							</div>
                        }
                        {menuStore.menu.data.contactDetails.whatsApp !== null &&
							<div className={style.websiteIcon}>
								<div className={style.detailsIcon}>
									<img src={whatsappIcon} alt=""/>
								</div>
								<a href={'https://wa.me/' + menuStore.menu.data.contactDetails.whatsApp}>
									<p>{menuStore.menu.data.contactDetails.whatsApp}</p>
								</a>
							</div>
                        }
                        {menuStore.menu.data.contactDetails.telegram !== null &&
                            <div className={style.websiteIcon}>
                                <div className={style.detailsIcon}>
                                    <img src={telegramIcon} alt=""/>
                                </div>
                                <a href={'tg://resolve?domain=' +`${menuStore.menu.data.contactDetails.telegram}`}>
                                    <p>{menuStore.menu.data.contactDetails.telegram}</p>
                                </a>
                            </div>
                        }
                    </div>


                    {
                        legalInfo &&
						<div
							className={style.legalInfo}
						>
							<p className={style.sectionTitle}>
								Юридическая информация ресторана
							</p>
							<p className={style.infoItem}>{legalInfo?.title}</p>
							<p className={style.infoItem}>{t('general:infoDetails.ogrn')}: {legalInfo?.ogrn}</p>
							<p className={style.infoItem}>{t('general:infoDetails.inn')}: {legalInfo?.inn}</p>
							<p className={style.infoItem}>{t('general:infoDetails.legalAddress')}: {legalInfo?.legalAddress}</p>
                            <p className={style.infoItem}>
								<Trans i18nKey="general:infoDetails.oferta">
									Используя меню, <br></br> вы соглашаетесь с <a href={'https://restify.one/documents/oferta'}>
									офертой</a>
								</Trans>
							</p>
						</div>
                    }

                </div>


                <div style={{
                    padding: 10
                }}>
                    <CloseButton onClick={closeInfoDetails}/>
                </div>
            </div>

        </>
    )
}

export default observer(InfoDetails);
